var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAttentionc8A8F118(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7248 11.8692L9.32385 0.782575C9.04097 0.292599 8.53428 0 7.96845 0C7.40262 0 6.89594 0.292534 6.61305 0.782575L0.212211 11.8692C-0.0707368 12.3592 -0.0707368 12.9443 0.212211 13.4343C0.495158 13.9243 1.00178 14.2169 1.56761 14.2169H14.3695C14.9353 14.2169 15.4419 13.9243 15.7248 13.4344C16.0077 12.9443 16.0076 12.3593 15.7248 11.8692ZM7.96852 12.4132C7.40677 12.4132 6.94977 11.9562 6.94977 11.3945C6.94977 10.8328 7.40677 10.3758 7.96852 10.3758C8.53027 10.3758 8.98727 10.8328 8.98727 11.3945C8.98721 11.9563 8.5302 12.4132 7.96852 12.4132ZM7.96852 9.08411C8.53402 9.08411 8.99414 8.624 8.99414 8.05849H8.9942V3.35132C8.9942 3.08301 8.77674 2.86549 8.50837 2.86549H7.42873C7.16042 2.86549 6.9429 3.08301 6.9429 3.35132V8.05849C6.9429 8.624 7.40301 9.08411 7.96852 9.08411Z",
    fill: "#D96865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttentionc8A8F118);
export default __webpack_public_path__ + "static/media/ic-attention.c8a8f118.c8a8f1187abc61f340eeb388829ea5e7.svg";
export { ForwardRef as ReactComponent };